import { render, staticRenderFns } from "./GoodFaithEstimateForMentalHealthServices.vue?vue&type=template&id=f469853c"
import script from "./GoodFaithEstimateForMentalHealthServices.vue?vue&type=script&lang=js"
export * from "./GoodFaithEstimateForMentalHealthServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports